import { get } from "lodash";

export default function(value) {
  const val = get(value, "value", { records: [] });
  if (!val || !val.records) {
    return { records: [] };
  }
  return val;
}
